<div class="fct-register-page">

  <!-- ══════════════════════════════════════════
       PANEL IZQUIERDO — Marca
  ══════════════════════════════════════════ -->
  <aside class="fct-brand" aria-hidden="true">
    <div class="fct-brand__inner">

      <div class="fct-brand__top">
        <img src="/assets/img/brand/handly-logo-lime-white.svg" alt="Handly" class="fct-brand__logo" />
        <span class="fct-brand__label">ERP · GESTIÓN EMPRESARIAL</span>
      </div>

      <div class="fct-brand__copy">
        <h1 class="fct-brand__headline">
          Empieza hoy.<br>Sin complicaciones.
        </h1>
        <p class="fct-brand__tagline">
          Facturación, contabilidad, tesorería y equipos en un único espacio de trabajo profesional.
        </p>
      </div>

      <!-- Progreso de alta — 3 pasos hasta tu primera factura -->
      <div class="fct-steps" aria-hidden="true">
        <div class="fct-steps__track">
          <div class="fct-steps__fill"></div>
        </div>
        <div class="fct-steps__row">
          <div class="fct-steps__item">
            <div class="fct-steps__circle">
              <svg class="fct-steps__icon" viewBox="0 0 24 24" fill="none">
                <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 8.5a7 7 0 0 1 14 0"
                      stroke="rgba(255,255,255,0.45)" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg class="fct-steps__check" viewBox="0 0 24 24" fill="none">
                <path d="M5 12.5l4.5 4.5L19 7" stroke="#0c1219" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="fct-steps__label">Crea tu cuenta</span>
          </div>
          <div class="fct-steps__item">
            <div class="fct-steps__circle">
              <svg class="fct-steps__icon" viewBox="0 0 24 24" fill="none">
                <path d="M4 21V9l8-5 8 5v12M4 21h16M9 21v-6h6v6"
                      stroke="rgba(255,255,255,0.45)" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg class="fct-steps__check" viewBox="0 0 24 24" fill="none">
                <path d="M5 12.5l4.5 4.5L19 7" stroke="#0c1219" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="fct-steps__label">Configura tu empresa</span>
          </div>
          <div class="fct-steps__item">
            <div class="fct-steps__circle">
              <svg class="fct-steps__icon" viewBox="0 0 24 24" fill="none">
                <path d="M6 2.5h9l3 3v16H6v-19Z" stroke="rgba(255,255,255,0.45)" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.5 9h7M8.5 12.5h7M8.5 16h4.5" stroke="rgba(255,255,255,0.45)" stroke-width="1.7" stroke-linecap="round"/>
              </svg>
              <svg class="fct-steps__check" viewBox="0 0 24 24" fill="none">
                <path d="M5 12.5l4.5 4.5L19 7" stroke="#0c1219" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="fct-steps__label">Primera factura</span>
          </div>
        </div>
      </div>

      <div class="fct-widget">
        <div class="fct-widget__head">
          <span class="fct-widget__period">Diciembre 2025</span>
          <span class="fct-widget__badge">↑ 12% vs mes anterior</span>
        </div>
        <div class="fct-widget__rows">
          <div class="fct-widget__row">
            <span class="fct-widget__concept">Ingresos facturados</span>
            <span class="fct-widget__amount fct-widget__amount--pos">24.840,00 €</span>
          </div>
          <div class="fct-widget__row">
            <span class="fct-widget__concept">Gastos registrados</span>
            <span class="fct-widget__amount fct-widget__amount--neg">8.120,50 €</span>
          </div>
          <div class="fct-widget__sep"></div>
          <div class="fct-widget__row fct-widget__row--total">
            <span class="fct-widget__concept">Balance neto</span>
            <span class="fct-widget__amount">16.719,50 €</span>
          </div>
        </div>
        <div class="fct-widget__progress">
          <div class="fct-widget__bar" style="width:67%"></div>
        </div>
        <p class="fct-widget__note">
          <span class="fct-widget__dot"></span>
          3 facturas pendientes de cobro · 1 vence esta semana
        </p>
      </div>

      <div class="fct-trust">
        <span>GDPR</span>
        <span class="fct-trust__sep">·</span>
        <span>TicketBAI</span>
        <span class="fct-trust__sep">·</span>
        <span>VeriFactu</span>
      </div>

    </div>
  </aside>


  <!-- ══════════════════════════════════════════
       PANEL DERECHO — Formulario
  ══════════════════════════════════════════ -->
  <main class="fct-form">
    <div class="fct-form__inner">

      <!-- Logo móvil -->
      <img src="/assets/img/brand/handly-icon.svg" alt="Handly" class="fct-mobile-logo" />

      <!-- Encabezado -->
      <header class="fct-form__header">
        <div class="fct-form__header-row">
          <h2 class="fct-form__title">Crea tu cuenta</h2>
          <p class="fct-header-login">
            ¿Ya tienes cuenta?
            <button type="button" class="fct-link fct-link--accent" (click)="login()">Inicia sesión</button>
          </p>
        </div>
        <p class="fct-form__sub">Empieza a gestionar tu empresa hoy mismo, gratis.</p>
      </header>

      <!-- Formulario -->
      <form [formGroup]="registerForm" (ngSubmit)="register()" autocomplete="off">

        <div class="fct-fields">

          <!-- Email -->
          <div class="fct-field-group fct-field-group--full">
            <label class="fct-label" for="reg-email">Correo electrónico</label>
            <mat-form-field appearance="outline" class="fct-mat-field">
              <input matInput id="reg-email" type="email" formControlName="Username"
                     autocomplete="email" placeholder="nombre@empresa.com" />
            </mat-form-field>
            <span class="fct-field-error"
                  *ngIf="registerForm.get('Username').touched && registerForm.get('Username').invalid">
              Introduce un correo electrónico válido.
            </span>
          </div>

          <!-- Contraseña -->
          <div class="fct-field-group fct-field-group--full">
            <label class="fct-label" for="reg-pw">Contraseña</label>
            <mat-form-field appearance="outline" class="fct-mat-field">
              <input matInput id="reg-pw" #pwInput
                     [type]="showNewPassword ? 'text' : 'password'"
                     formControlName="Password"
                     autocomplete="new-password"
                     placeholder="Mínimo 8 caracteres" />
              <button matSuffix mat-icon-button type="button"
                      class="fct-pw-toggle"
                      (click)="showPassword(pwInput)"
                      [attr.aria-label]="showNewPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                <mat-icon>{{ showNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </mat-form-field>
            <span class="fct-field-error"
                  *ngIf="registerForm.get('Password').touched && registerForm.get('Password').invalid">
              La contraseña debe tener al menos 8 caracteres.
            </span>
          </div>

          <!-- CIF / NIF -->
          <div class="fct-field-group fct-field-group--full">
            <label class="fct-label" for="reg-vat">Identificador fiscal <span class="fct-label-hint">(CIF/NIF)</span></label>
            <mat-form-field appearance="outline" class="fct-mat-field">
              <input matInput id="reg-vat" type="text" formControlName="VatNumber"
                     placeholder="B12345678 / 12345678A" />
            </mat-form-field>
            <span class="fct-field-error"
                  *ngIf="registerForm.get('VatNumber').touched && registerForm.get('VatNumber').invalid">
              Este campo es obligatorio.
            </span>
          </div>

          <!-- Razón social (jurídica / sin determinar) -->
          <ng-container *ngIf="parametrizationId === 2 || parametrizationId === 1003">
            <div class="fct-field-group fct-field-group--full">
              <label class="fct-label">Razón Social / Nombre</label>
              <mat-form-field appearance="outline" class="fct-mat-field">
                <input matInput type="text" formControlName="CompanyName" />
              </mat-form-field>
              <span class="fct-field-error"
                    *ngIf="registerForm.get('CompanyName').touched && registerForm.get('CompanyName').invalid">
                Este campo es obligatorio.
              </span>
            </div>
          </ng-container>

          <!-- Apellidos + Nombre (persona física) -->
          <ng-container *ngIf="parametrizationId === 3">
            <div class="fct-field-group">
              <label class="fct-label">Apellidos</label>
              <mat-form-field appearance="outline" class="fct-mat-field">
                <input matInput type="text" formControlName="CompanyName" />
              </mat-form-field>
              <span class="fct-field-error"
                    *ngIf="registerForm.get('CompanyName').touched && registerForm.get('CompanyName').invalid">
                Este campo es obligatorio.
              </span>
            </div>
            <div class="fct-field-group">
              <label class="fct-label">Nombre</label>
              <mat-form-field appearance="outline" class="fct-mat-field">
                <input matInput type="text" formControlName="Name" />
              </mat-form-field>
              <span class="fct-field-error"
                    *ngIf="registerForm.get('Name').touched && registerForm.get('Name').invalid">
                Este campo es obligatorio.
              </span>
            </div>
          </ng-container>

          <!-- País -->
          <div class="fct-field-group">
            <label class="fct-label">País</label>
            <mat-form-field appearance="outline" class="fct-mat-field">
              <input matInput [matAutocomplete]="autoCountries"
                     (input)="filterItemsCountries($event.target.value)"
                     cdkAutofill (cdkAutofill)="onCountryAutofill($event)"
                     formControlName="countriesCode"
                     autocomplete="new-country" />
              <mat-autocomplete #autoCountries="matAutocomplete" [displayWith]="displayFnCountries">
                <mat-option *ngFor="let item of countriesFiltered; trackBy: trackByIndex" [value]="item.numerico">
                  {{ item.countryName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <span class="fct-field-error"
                  *ngIf="registerForm.get('countriesCode').touched && registerForm.get('countriesCode').invalid">
              Selecciona un país.
            </span>
          </div>

          <!-- Provincia -->
          <div class="fct-field-group">
            <label class="fct-label">Provincia</label>
            <mat-form-field appearance="outline" class="fct-mat-field">
              <input matInput [matAutocomplete]="auto"
                     (input)="filterItems($event.target.value)"
                     cdkAutofill (cdkAutofill)="onProvinceAutofill($event)"
                     formControlName="ProvinceCode"
                     autocomplete="new-province" />
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let item of provincesFiltered; trackBy: trackByIndex" [value]="item.provinceCode">
                  {{ item.provinceName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <span class="fct-field-error"
                  *ngIf="registerForm.get('ProvinceCode').touched && registerForm.get('ProvinceCode').invalid">
              Selecciona una provincia.
            </span>
          </div>

          <!-- Teléfono -->
          <div class="fct-field-group fct-field-group--full">
            <label class="fct-label">
              Teléfono <span class="fct-label-hint">(opcional)</span>
            </label>
            <mat-form-field appearance="outline" class="fct-mat-field">
              <input matInput type="tel" formControlName="PhoneNumber"
                     autocomplete="tel" placeholder="+34 600 000 000" />
            </mat-form-field>
          </div>

        </div><!-- /fct-fields -->

        <!-- Checkboxes -->
        <div class="fct-checks">
          <label class="fct-remember">
            <input type="checkbox" class="fct-check__input" formControlName="checked" />
            <span class="fct-check__box" aria-hidden="true"></span>
            <span class="fct-check__text">
              He leído y acepto la
              <button type="button" class="fct-link fct-link--accent" (click)="openPrivacy()">
                Política de Privacidad
              </button>
            </span>
          </label>

          <label class="fct-remember">
            <input type="checkbox" class="fct-check__input" formControlName="Newsletter" />
            <span class="fct-check__box" aria-hidden="true"></span>
            <span class="fct-check__text">Deseo recibir información y noticias</span>
          </label>
        </div>

        <!-- LOPD -->
        <p class="fct-lopd">
          <strong>Responsable:</strong> Herlec Innovations, S.L. — CIF B7573191.
          Datos tratados para el registro como usuario conforme al RGPD.
          <button type="button" class="fct-link" (click)="openPrivacy()">Más información</button>
        </p>

        <!-- Botón principal -->
        <button type="submit"
                class="fct-submit"
                [class.fct-submit--loading]="isSubmitting"
                [disabled]="!registerForm.valid || isSubmitting">
          <ng-container *ngIf="!isSubmitting">
            <span>Crear cuenta gratis</span>
            <svg class="fct-submit__arrow" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4"
                    stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </ng-container>
          <span class="fct-dots" *ngIf="isSubmitting" aria-label="Cargando">
            <span></span><span></span><span></span>
          </span>
        </button>

      </form>

      <!-- Footer -->
      <footer class="fct-form__footer">
      </footer>

    </div>
  </main>

  <!-- ══════════════════════════════════════════
       Overlay — Procesando registro
  ══════════════════════════════════════════ -->
  <div class="fct-processing" *ngIf="isSubmitting" aria-live="polite">
    <div class="fct-processing__card">
      <div class="fct-processing__icon">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 2a7 7 0 0 1 7 7v1h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h1V9a7 7 0 0 1 7-7z"
                stroke="#f59e0b" stroke-width="1.5" stroke-linecap="round"/>
          <circle cx="12" cy="16" r="1.5" fill="#f59e0b"/>
        </svg>
      </div>
      <div class="fct-dots fct-dots--dark">
        <span></span><span></span><span></span>
      </div>
      <h3 class="fct-processing__title">Creando tu cuenta</h3>
      <p class="fct-processing__sub">Esto puede tardar unos segundos.<br>No cierres la página.</p>
    </div>
  </div>

  <!-- ══════════════════════════════════════════
       Overlay — Registro completado
  ══════════════════════════════════════════ -->
  <div class="fct-success" *ngIf="isVisible && !registerForm.get('IsConsultant').value">
    <div class="fct-success__card">
      <div class="fct-success__icon">
        <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
          <circle cx="24" cy="24" r="22" stroke="#16a34a" stroke-width="2"/>
          <path d="M14 24.5l7 7 13-14"
                stroke="#16a34a" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h2 class="fct-success__title">¡Registro completado!</h2>
      <p class="fct-success__sub">
        Hemos enviado un enlace de activación a tu correo.<br>
        Revisa también tu bandeja de <strong>spam</strong>.
      </p>
      <button type="button" class="fct-submit" (click)="login()">
        <span>Ir al inicio de sesión</span>
        <svg class="fct-submit__arrow" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M3 8h10M9 4l4 4-4 4"
                stroke="currentColor" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>

</div>

